import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import BEMHelper from 'react-bem-helper';
import _ from 'lodash';
import Select from '@splunk/react-ui/Select';
import Text from '@splunk/react-ui/Text';

const className = new BEMHelper('information-durationinput');

const VALID_DURATION_PATTERN = /^([0-9]+)([mhd]){1}$/i;
const DEFAULT_UNIT = 'd';
const DEFAULT_NUMBER = 1;

const unitOptions = [
    {
        id: 'm',
        title: 'minutes',
    },
    {
        id: 'h',
        title: 'hours',
    },
    {
        id: 'd',
        title: 'days',
    },
];

function getDurationString(number, unit) {
    return `${number}${unit}`;
}

function isValidDuration(duration) {
    return !!duration.match(VALID_DURATION_PATTERN);
}

export default function InformationDurationInput({ label, onChange, value, additionalInfo }) {
    const [checked, setChecked] = useState(false);
    const [number, setNumber] = useState(DEFAULT_NUMBER);
    const [unit, setUnit] = useState(DEFAULT_UNIT);

    useEffect(() => {
        if (value && isValidDuration(value)) {
            const matches = value.match(VALID_DURATION_PATTERN);
            if (matches && matches.length >= 3) {
                setChecked(true);
                setNumber(matches[1]);
                setUnit(matches[2]);
            }
        }
    }, [value]);

    const handleChangeCheckbox = () => {
        const newValue = !checked;
        if (newValue) {
            const newDurationString = getDurationString(number, unit);
            onChange(newDurationString, isValidDuration(newDurationString));
        } else {
            // Saving as an empty string instead of null as the API gives 502 on saving null.
            onChange('', true);
        }
        setChecked(newValue);
    };

    const handleChangeNumber = (_, { value }) => {
        const newDurationString = getDurationString(value, unit);
        onChange(newDurationString, isValidDuration(newDurationString));
        setNumber(value);
    };

    const handleChangeUnit = (_, { value }) => {
        const newDurationString = getDurationString(number, value);
        onChange(newDurationString, isValidDuration(newDurationString));
        setUnit(value);
    };

    const additionalInfoList = _.map(additionalInfo, (infoStr, index) => {
        return <div key={index}>{infoStr}</div>;
    });

    return (
        <div {...className()}>
            <label>
                <input
                    type="checkbox"
                    name={label}
                    checked={checked}
                    onClick={handleChangeCheckbox}
                    readOnly
                />
                <span {...className('input-label')}>{label}</span>
                {checked && (
                    <>
                        <Text
                            {...className(
                                'duration-number',
                                isValidDuration(value) ? null : 'invalid'
                            )}
                            type="number"
                            inline
                            name={label}
                            onChange={handleChangeNumber}
                            value={number}
                        />
                        <Select
                            {...className('dropdown-select')}
                            value={unit}
                            onChange={handleChangeUnit}
                        >
                            {unitOptions.map((unit) => (
                                <Select.Option key={unit.id} value={unit.id} label={unit.title} />
                            ))}
                        </Select>
                    </>
                )}
            </label>
            <div {...className('additional-information')}>{additionalInfoList}</div>
        </div>
    );
}

InformationDurationInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    additionalInfo: PropTypes.array,
};
